import Super from '../../core/button.gjs';
import styles from './tertiary.module.scss';

const METADATA = {
  component: 'Spds::Action::Button::Tertiary',
  description: `
    Tertiary button used to perform an action.

    Extends the SPDS Core Button component.
  `,
  name: 'Tertiary Button',
  resources: {
    github:
      'https://github.com/simplepractice/ember-simplepractice/tree/staging/addon/src/components/spds/action/button/tertiary.gjs',
  },
};

export default class SpdsActionButtonTertiary extends Super {
  static metadata = this.setMetadata(METADATA);
  baseClass = 'spds-button spds-action-button';
  hasBorder = true;
  variantClass = 'spds-action-button-tertiary';
  variantStyles = styles;
}

export const ACTION_BUTTON_TERTIARY_METADATA = SpdsActionButtonTertiary.metadata;
